<template>
  <div>
    <v-progress-linear
      height="10"
      :value="donationPercentage"
      striped
      color="primary"
      class="mb-1"
      rounded
    />
    <div class="d-flex flex-row">
      <span v-show="totalDonations > 0">{{ totalDonations.toLocaleString() }} {{ currencyUnit }} {{ t("RECOLTES") }}</span>
      <div class="d-flex flex-column ml-auto">
        <div v-if="!goalReached">
          {{ t("OBJECTIF") }} :
          <span class="font-weight-bold">{{ goal.toLocaleString() }} {{ currencyUnit }}</span>
        </div>
        <div v-else>
          <span class="font-weight-bold primary--text">{{ t("OBJECTIF") }} {{ t("DE") }} {{ goal.toLocaleString() }} {{ currencyUnit }} {{ t("ATTEINT") }} !</span>
        </div>
        <span
          v-show="showRemainingTime"
          class="warning--text darken-2"
        >{{ remainingDays }} {{ t("JOURS_RESTANTS") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  props: {
    campaign: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapGetters(["formParams", "currency", "t"]),
    remainingDays: function () {
      if (!this.campaign.campaignEnd) {
        return undefined
      }
      return Math.round((new Date(this.campaign.campaignEnd) - new Date()) / (1000 * 60 * 60 * 24))
    },
    goal: function () {
      return this.campaign.objective
    },
    totalDonations: function () {
      if (!this.campaign) {
        return 0
      }
      return this.campaign.totalDonations || 0
    },
    donationPercentage: function () {
      return (this.totalDonations / this.goal) * 100
    },
    goalReached() {
      return this.totalDonations > this.goal
    },
    showRemainingTime() {
      return this.remainingDays && !this.goalReached
    },
    currencyUnit() {
      return this.currency.unit
    }
  }
}
</script>

<style scoped>
#goal {
  justify-self: end;
}
</style>